/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tl_No_DatesInputs */

const en_tl_no_dates = /** @type {(inputs: Tl_No_DatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`no dates`)
};

const de_tl_no_dates = /** @type {(inputs: Tl_No_DatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ohne Termine`)
};

/**
* | output |
* | --- |
* | "no dates" |
*
* @param {Tl_No_DatesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tl_no_dates = /** @type {((inputs?: Tl_No_DatesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tl_No_DatesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tl_no_dates(inputs)
	return en_tl_no_dates(inputs)
});